module.exports = __webpack_public_path__ + "img/safe_01.b50503db.png";